<div class="container-fluid  mt-5 pt-5"
  style="  background: linear-gradient(to right,#273C66 , #273C66);  font-family: 'Poppins', sans-serif; " >

<div class="container">
  <div class="row" style="color: #ecf0f3;">
    <div class="col-md-3  col-12 ">
      <div class="main-Address text-start mb-5">
        <div>
          <img  src="assets\Snp_logo.png" class="img-fluid my-4" style="width:70%" alt="image not found" />
        </div>
        <div class="mb-0 my-1">
          <a  style="text-decoration:none;">
            <i  class="fa fa-twitter-square fa-2x mx-1" aria-hidden="true"></i></a>
          <a  style="text-decoration:none ">
             <i class="fa fa-facebook-square fa-2x mx-1" aria-hidden="true"></i></a>
          <a  style="text-decoration:none">
            <i class="fa fa-instagram fa-2x mx-1" aria-hidden="true"></i></a>
          <a href="" style="text-decoration:none">
            <i class="fa fa-linkedin-square fa-2x mx-1" aria-hidden="true"></i></a>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-12 justify-content-center mt-2">
      <h2 class="hidden-mobile">Who we are</h2>
      <h2 class="show-mobile">Who we are</h2>
      <div class="row mb-3">
        <p class="py-1">
            <a class="bigtext" style="text-decoration: none;" href="/aboutUs">About Us</a>
        </p>
        <p class="py-1">
            <a class="bigtext" style="text-decoration: none;" href="/contactUs">Contact Us</a>
        </p>
        <p class="py-1">
            <a class="bigtext" style="text-decoration: none;" href="/blog">Blogs</a>
        </p>
    </div>

    </div>
    <div class="col-md-3 col-12 justify-content-center mt-2">
      <h2 class="hidden-mobile">Resources</h2>
      <h2 class="  show-mobile">Resources</h2>
      <div class="row mb-3">
     <div class="col-md-12">
          <p class="my-1"> <a class="bigtext"  style="text-decoration:none"> Fund Explorer </a></p>
          <p class="my-3"> <a class="bigtext"  style="text-decoration:none"> Calculators</a></p>



        </div>
      </div>
    </div>
    <div class="col-md-3 col-12  my-2  text-start">
      <h2 class="text-start ">Address</h2>
      <p class="py-1"> <a class="bigtext"  style="text-decoration:none">SNP Wealth Private Limited</a></p>
      <p class="py-1 "> <a class="bigtext"  style="text-decoration:none ">Office No. 254, 2nd Floor, Vision 9 Mall, Pimple Saudagar, Pune 411027</a></p>

    </div>
  </div>


  <div class="col-lg-12 col-md-12 col-sm-12"  style="color: #ffffff;">
    <div class="vline ">&nbsp;</div>
    <div class="copyright">
        <div class="copyright_content_other">
       <h4>Mutual Fund Sahi hain...SNP Money Mutual Fund ke liye sahi hain</h4>
       <p>SNP Money is growing automated platform for mutual fund investing. It enables investor to choose best
          funds from across the fund universe.
       </p>
       <p>It chooses best of the funds from Top Equity Fund, Top Debt Fund, Top Tax Saving Fund, Top Balanced
          Fund, Top Debt Fund &amp; Top Liquid Funds. It allows investor to invest in completely paperless manner in
          both Lumpsum &amp; SIP investment.
       </p>
       <p>SNP Money provides highest of the security so that investor can focus on his investments. SNP Money
          offers many benefits some of which are
       </p>
       <ul>
          Completely digital platform
          Customized portfolio for every investor.
          No Demat account
          No Fees. No Charges.
          Start with Minimum Investment of ₹ 500/-
       </ul>
       <p>What is SIP | SIP Mutual Funds | SIP Plans | High Growth SIP | SBI SIP | SIP Plans| SIP Calculator
       </p>
       <div class="vline">&nbsp;</div>
       <p>Top Mutual Funds</p>
       <p>Axis Long Term Equity Fund - Growth | Kotak Taxsaver - Regular - Growth | Aditya Birla Sun Life Tax
          Relief 96 - Growth | DSP Tax Saver Fund - Growth | Invesco India Tax Plan - Growth | IDFC Tax
          Advantage (ELSS) Fund - Regular - Growth | ICICI Prudential Long Term Equity Fund (Tax Saving) |
          Canara Robeco Equity Tax Saver Fund - Growth | Principal Tax Savings Fund | ICICI Prudential Asset
          Allocator Fund - Growth | ICICI Prudential Regular Savings Fund - Growth | Franklin India Dynamic PE
          Ratio Fund Of Funds - Growth | UTI Regular Savings Fund - Growth | Reliance Hybrid Bond Fund - Growth
          | Franklin India Debt Hybrid Fund - Growth | BNP Paribas Conservative Hybrid Fund - Growth | SBI Debt
          Hybrid Fund - Growth | ICICI Prudential Equity &amp; Debt Fund - Growth | Principal Hybrid Equity Fund -
          Growth | SBI Equity Hybrid Fund - Growth | HDFC Hybrid Equity Fund - Growth | ICICI Prudential
          Balanced Advantage Fund - Regular - Growth | Canara Robeco Equity Hybrid Fund - Growth | ICICI
          Prudential Multi-Asset Fund - Growth | HDFC Balanced Advantage Fund - Growth | SBI Small Cap Fund -
          Growth | Mirae Asset Large Cap Fund - Regular - Growth | Parag Parikh Long Term Equity Fund - Regular
          - Growth | SBI Focused Equity Fund - Growth | Kotak Standard Multicap Fund - Regular - Growth |
          Motilal Oswal Multicap 35 Fund - Regular - Growth | Franklin India Feeder - Franklin U.S.
          Opportunities Fund - Growth | Canara Robeco Emerging Equities - Growth | Mirae Asset Great Consumer
          Fund - Growth
       </p>
       <p>Tax Saving ELSS Mutual Funds</p>
       <p>Best ELSS Fund | Top Tax Saving Fund | ELSS Mutual Fund | Tax Saver | ELSS Calculator | Save Tax |
          Best Tax Saving Mutual Funds
       </p>
       <p>SNP Money, AMFI-registered Mutual Fund Distributor with ARN-173623, owns and
          operate SNP Money.com and application on Google Play by the name of 'SNP Money'. do not warranty or
          represent, express or imply, on products which are offered by the platform. It accepts no liability
          for any damages or losses occurred in connection with the use of the services at the website. Terms
          and conditions of the website are applicable to every one who visits or accesses the services. The
          recommendations or fund suggestions are incidental or ancillary to the mutual fund distribution. The
          information and suggestions provided by SNP Money.com is for informative purpose only and in no context
          related to an investment or tax advice. The data or figures available on the website are solely for
          illustrative purpose to provide information.
       </p>
            <p style="text-align:center;">Mutual fund investments are subject to market risks. Please read the scheme information and other related documents carefully before investing.</p>

            <p style="text-align:center;">SNP Wealth Private Limited - A AMFI Registered Mutual Fund Distributor.</p>
          </div>
        <!-- copyright content -->
    </div>
    <!-- copyright -->
  </div>
</div>

<div class="row px-4 py-3" style="color: white; background-color: #485a80;">
  <div class="col-md-6 d-flex gap-2">
    <a [routerLink]="['/term']">Terms of Use</a> |
    <a [routerLink]="['/privacy']">Privacy Policy</a> |
    <a [routerLink]="['/disclosure']">Disclosure</a> |
    <a [routerLink]="['/webinar']">Webinar</a>
  </div>


  <div class="col-md-6 text-md-end text-center mt-2 mt-md-0">
    © Copyright: <a href="https://snpmoney.com" style="color: white;">SNP Money</a> All rights reserved
  </div>
</div>

